<div class="container">
    <div class="row">
        <div class="col">
            <p>Selecciona paleta de colores</p>
            <button type="button" class="btn btn-primary">V1</button>
            <button type="button" class="btn btn-primary">V2</button>
        </div>
        <div class="col">
            <p>Selecciona modo claro/oscuro</p>
            <button type="button" class="btn btn-info">Light</button>
            <button type="button" class="btn btn-dark">Dark</button>
        </div>
    </div>
    <div class="row">
        <h1>Iconos</h1>
        <div class="col">
            <div class="container">
                <h2>bi bi-car-front</h2>
                <div class="row text-center">
                    <div class="col">
                        <i class="bi bi-car-front circle-primary big"></i>
                        <br />
                        <code>circle-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front circle-secondary big"></i>
                        <br />
                        <code>circle-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front circle-featured big"></i>
                        <br />
                        <code>circle-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front circle-white-primary big"></i>
                        <br />
                        <code>circle-white-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front circle-white-secondary big"></i>
                        <br />
                        <code>circle-white-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front circle-white-featured big"></i>
                        <br />
                        <code>circle-white-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front primary big"></i>
                        <br />
                        <code>primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front secondary big"></i>
                        <br />
                        <code>secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-car-front featured big"></i>
                        <br />
                        <code>featured</code>
                    </div>
                </div>
                <h2>bi bi-person-wheelchair</h2>
                <div class="row text-center">
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-primary big"></i>
                        <br />
                        <code>circle-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-secondary big"></i>
                        <br />
                        <code>circle-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-featured big"></i>
                        <br />
                        <code>circle-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-white-primary big"></i>
                        <br />
                        <code>circle-white-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-white-secondary big"></i>
                        <br />
                        <code>circle-white-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair circle-white-featured big"></i>
                        <br />
                        <code>circle-white-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair primary big"></i>
                        <br />
                        <code>primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair secondary big"></i>
                        <br />
                        <code>secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-person-wheelchair featured big"></i>
                        <br />
                        <code>featured</code>
                    </div>
                </div>
                <h2>bi bi-bar-chart-line</h2>
                <div class="row text-center">
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-primary big"></i>
                        <br />
                        <code>circle-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-secondary big"></i>
                        <br />
                        <code>circle-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-featured big"></i>
                        <br />
                        <code>circle-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-white-primary big"></i>
                        <br />
                        <code>circle-white-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-white-secondary big"></i>
                        <br />
                        <code>circle-white-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line circle-white-featured big"></i>
                        <br />
                        <code>circle-white-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line primary big"></i>
                        <br />
                        <code>primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line secondary big"></i>
                        <br />
                        <code>secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-bar-chart-line featured big"></i>
                        <br />
                        <code>featured</code>
                    </div>
                </div>
                <h2>bi bi-calendar-week</h2>
                <div class="row text-center">
                    <div class="col">
                        <i class="bi bi-calendar-week circle-primary big"></i>
                        <br />
                        <code>circle-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week circle-secondary big"></i>
                        <br />
                        <code>circle-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week circle-featured big"></i>
                        <br />
                        <code>circle-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week circle-white-primary big"></i>
                        <br />
                        <code>circle-white-primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week circle-white-secondary big"></i>
                        <br />
                        <code>circle-white-secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week circle-white-featured big"></i>
                        <br />
                        <code>circle-white-featured</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week primary big"></i>
                        <br />
                        <code>primary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week secondary big"></i>
                        <br />
                        <code>secondary</code>
                    </div>
                    <div class="col">
                        <i class="bi bi-calendar-week featured big"></i>
                        <br />
                        <code>featured</code>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Formularios</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <p>CAMPO DE TEXTO</p>
                        <input type="text" class="form-control" placeholder="Ejemplo" />
                    </div>
                    <div class="col">
                        <p>VALIDACIÓN CORRECTA</p>
                        <input type="text" class="form-control is-valid" value="Mark" required>
                        <div class="valid-feedback">
                            Correcto!
                        </div>
                    </div>
                    <div class="col">
                        <p>VALIDACIÓN INCORRECTA</p>
                        <input type="text" class="form-control is-invalid" placeholder="Ejemplo" />
                        <div class="invalid-feedback">
                            Introduce un valor válido
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <p>SELECCIONABLE</p>
                        <select class="form-select" aria-label="Default select example">
                            <option disabled>Ejemplo</option>
                            <option value="1">Uno</option>
                            <option value="2">Dos</option>
                            <option value="3">Tres</option>
                        </select>
                    </div>
                    <div class="col">
                        <p>VALIDACIÓN CORRECTA</p>
                        <select class="form-select  is-valid" required>
                            <option disabled value="">Ejemplo</option>
                            <option selected value="1">Uno</option>
                            <option value="2">Dos</option>
                            <option value="3">Tres</option>
                        </select>
                        <div class="valid-feedback">
                            Correcto!
                        </div>
                    </div>
                    <div class="col">
                        <p>VALIDACIÓN INCORRECTA</p>
                        <select class="form-select is-invalid" required>
                            <option selected disabled value="">Ejemplo</option>
                            <option value="1">Uno</option>
                            <option value="2">Dos</option>
                            <option value="3">Tres</option>
                        </select>
                        <div class="invalid-feedback">
                            Introduce un valor válido
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                            <label class="form-check-label" for="flexCheckDefault">
                                No Seleccionado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input primary" type="checkbox" value="" id="flexCheckChecked" checked>
                            <label class="form-check-labe primary" for="flexCheckChecked">
                                Seleccionado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefaultDisabled"
                                disabled>
                            <label class="form-check-label" for="flexCheckDefault">
                                No Seleccionado Deshabilitado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckCheckedDisabled"
                                checked disabled>
                            <label class="form-check-label" for="flexCheckChecked">
                                Seleccionado Deshabilitado
                            </label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                            <label class="form-check-label" for="flexRadioDefault1">
                                No Seleccionado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                                checked>
                            <label class="form-check-label" for="flexRadioDefault2">
                                Seleccionado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDisabled" id="flexRadioDisabled"
                                disabled>
                            <label class="form-check-label" for="flexRadioDisabled">
                                No Seleccionado Deshabilitado
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDisabled"
                                id="flexRadioCheckedDisabled" checked disabled>
                            <label class="form-check-label" for="flexRadioCheckedDisabled">
                                Seleccionado Deshabilitado
                            </label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                            <label class="form-check-label" for="flexSwitchCheckDefault">
                                No Seleccionado
                            </label>
                        </div>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked"
                                checked>
                            <label class="form-check-label" for="flexSwitchCheckChecked">
                                Seleccionado
                            </label>
                        </div>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDisabled"
                                disabled>
                            <label class="form-check-label" for="flexSwitchCheckDisabled">
                                No Seleccionado Deshabilitado
                            </label>
                        </div>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                id="flexSwitchCheckCheckedDisabled" checked disabled>
                            <label class="form-check-label" for="flexSwitchCheckCheckedDisabled">
                                Seleccionado Deshabilitado
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Botones</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <p>Botón primario</p>
                        <button type="button" class="btn btn-primary">Primary</button>
                    </div>
                    <div class="col">
                        <p>Botón secundario</p>
                        <button type="button" class="btn btn-secondary">Secondary</button>
                    </div>
                    <div class="col">
                        <p>Botón destacado</p>
                        <button type="button" class="btn btn-warning">Featured</button>
                    </div>
                    <div class="col">
                        <p>Botón deshabilitado</p>
                        <button type="button" class="btn btn-secondary" disabled>Disabled</button>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn btn-outline-primary">Primary</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-outline-secondary">Secondary</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-outline-warning">featured</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-outline-secondary" disabled>Disabled</button>
                    </div>
                </div>
            </div>
        </div>
        <h1>Links</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <p>Link primario</p>
                        <p><a href="#"
                                class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">Primary
                                link</a></p>
                    </div>
                    <div class="col">
                        <p>Link secundario</p>
                        <p><a href="#"
                                class="link-secondary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">Secondary
                                link</a></p>
                    </div>
                    <div class="col">
                        <p>Link destacado</p>
                        <p><a href="#"
                                class="link-warning link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">Featured
                                link</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Acordeones</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="accordion primary" id="accordionExample">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Accordion Item #1
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <strong>This is the first item's accordion body.</strong> It is shown by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Accordion Item #2
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <strong>This is the second item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Accordion Item #3
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <strong>This is the third item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="accordion secondary" id="accordionExample2">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne2" aria-expanded="true"
                                        aria-controls="collapseOne2">
                                        Accordion Item #1
                                    </button>
                                </h2>
                                <div id="collapseOne2" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <strong>This is the first item's accordion body.</strong> It is shown by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo2" aria-expanded="false"
                                        aria-controls="collapseTwo2">
                                        Accordion Item #2
                                    </button>
                                </h2>
                                <div id="collapseTwo2" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <strong>This is the second item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree2" aria-expanded="false"
                                        aria-controls="collapseThree2">
                                        Accordion Item #3
                                    </button>
                                </h2>
                                <div id="collapseThree2" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample2">
                                    <div class="accordion-body">
                                        <strong>This is the third item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="accordion featured" id="accordionExample3">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne3" aria-expanded="true"
                                        aria-controls="collapseOne3">
                                        Accordion Item #1
                                    </button>
                                </h2>
                                <div id="collapseOne3" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordionExample3">
                                    <div class="accordion-body">
                                        <strong>This is the first item's accordion body.</strong> It is shown by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo3" aria-expanded="false"
                                        aria-controls="collapseTwo3">
                                        Accordion Item #2
                                    </button>
                                </h2>
                                <div id="collapseTwo3" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample3">
                                    <div class="accordion-body">
                                        <strong>This is the second item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree3" aria-expanded="false"
                                        aria-controls="collapseThree3">
                                        Accordion Item #3
                                    </button>
                                </h2>
                                <div id="collapseThree3" class="accordion-collapse collapse"
                                    data-bs-parent="#accordionExample3">
                                    <div class="accordion-body">
                                        <strong>This is the third item's accordion body.</strong> It is hidden by
                                        default, until the collapse plugin adds the appropriate classes that we use to
                                        style each element. These classes control the overall appearance, as well as the
                                        showing and hiding via CSS transitions. You can modify any of this with custom
                                        CSS or overriding our default variables. It's also worth noting that just about
                                        any HTML can go within the <code>.accordion-body</code>, though the transition
                                        does limit overflow.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Pestañas</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <ul class="nav nav-tabs primary" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                    data-bs-target="#home-tab-pane" type="button" role="tab"
                                    aria-controls="home-tab-pane" aria-selected="true">Home</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                    data-bs-target="#profile-tab-pane" type="button" role="tab"
                                    aria-controls="profile-tab-pane" aria-selected="false">Profile</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="contact-tab" data-bs-toggle="tab"
                                    data-bs-target="#contact-tab-pane" type="button" role="tab"
                                    aria-controls="contact-tab-pane" aria-selected="false">Contact</button>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                                obcaecati corrupti aliquid sequi! Vero, sint natus dolores eligendi dignissimos
                                repudiandae earum itaque dolor error aliquid debitis minus nulla placeat ad totam eius
                                soluta! Provident, sapiente porro omnis perspiciatis impedit dicta?</div>
                            <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Aperiam consectetur incidunt sint laboriosam, atque dolorum adipisci
                                non culpa deleniti quidem accusantium minus, reprehenderit mollitia voluptatibus dolore
                                accusamus. Dolorum ipsum enim facere eveniet culpa corrupti amet, illum in
                                necessitatibus iste minima quam recusandae labore. Iure at quisquam quis quas inventore
                                non.</div>
                            <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur,
                                adipisicing elit. Ratione, iste aliquam? Nisi perferendis libero id ex consequatur
                                numquam illo eligendi commodi totam! Distinctio repellat incidunt magni tempora earum
                                explicabo expedita sed pariatur, molestias, aut ipsa, cumque eius ad. Officia fugit eius
                                eaque, nisi quidem qui ea hic repellat omnis dolores.</div>
                        </div>
                    </div>
                    <div class="col">
                        <ul class="nav nav-tabs secondary" id="myTab2" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="home-tab2" data-bs-toggle="tab"
                                    data-bs-target="#home-tab-pane2" type="button" role="tab"
                                    aria-controls="home-tab-pane2" aria-selected="true">Home</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="profile-tab2" data-bs-toggle="tab"
                                    data-bs-target="#profile-tab2-pane" type="button" role="tab"
                                    aria-controls="profile-tab2-pane" aria-selected="false">Profile</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="contact-tab2" data-bs-toggle="tab"
                                    data-bs-target="#contact-tab2-pane" type="button" role="tab"
                                    aria-controls="contact-tab2-pane" aria-selected="false">Contact</button>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTab2Content">
                            <div class="tab-pane fade show active" id="home-tab-pane2" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                                obcaecati corrupti aliquid sequi! Vero, sint natus dolores eligendi dignissimos
                                repudiandae earum itaque dolor error aliquid debitis minus nulla placeat ad totam eius
                                soluta! Provident, sapiente porro omnis perspiciatis impedit dicta?</div>
                            <div class="tab-pane fade" id="profile-tab2-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Aperiam consectetur incidunt sint laboriosam, atque dolorum adipisci
                                non culpa deleniti quidem accusantium minus, reprehenderit mollitia voluptatibus dolore
                                accusamus. Dolorum ipsum enim facere eveniet culpa corrupti amet, illum in
                                necessitatibus iste minima quam recusandae labore. Iure at quisquam quis quas inventore
                                non.</div>
                            <div class="tab-pane fade" id="contact-tab2-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur,
                                adipisicing elit. Ratione, iste aliquam? Nisi perferendis libero id ex consequatur
                                numquam illo eligendi commodi totam! Distinctio repellat incidunt magni tempora earum
                                explicabo expedita sed pariatur, molestias, aut ipsa, cumque eius ad. Officia fugit eius
                                eaque, nisi quidem qui ea hic repellat omnis dolores.</div>
                        </div>
                    </div>
                    <div class="col">
                        <ul class="nav nav-tabs featured" id="myTab3" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="home-tab3" data-bs-toggle="tab"
                                    data-bs-target="#home-tab3-pane" type="button" role="tab"
                                    aria-controls="home-tab3-pane" aria-selected="true">Home</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="profile-tab3" data-bs-toggle="tab"
                                    data-bs-target="#profile-tab3-pane" type="button" role="tab"
                                    aria-controls="profile-tab3-pane" aria-selected="false">Profile</button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="contact-tab3" data-bs-toggle="tab"
                                    data-bs-target="#contact-tab3-pane" type="button" role="tab"
                                    aria-controls="contact-tab3-pane" aria-selected="false">Contact</button>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTab3Content">
                            <div class="tab-pane fade show active" id="home-tab3-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                                obcaecati corrupti aliquid sequi! Vero, sint natus dolores eligendi dignissimos
                                repudiandae earum itaque dolor error aliquid debitis minus nulla placeat ad totam eius
                                soluta! Provident, sapiente porro omnis perspiciatis impedit dicta?</div>
                            <div class="tab-pane fade" id="profile-tab3-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur
                                adipisicing elit. Aperiam consectetur incidunt sint laboriosam, atque dolorum adipisci
                                non culpa deleniti quidem accusantium minus, reprehenderit mollitia voluptatibus dolore
                                accusamus. Dolorum ipsum enim facere eveniet culpa corrupti amet, illum in
                                necessitatibus iste minima quam recusandae labore. Iure at quisquam quis quas inventore
                                non.</div>
                            <div class="tab-pane fade" id="contact-tab3-pane" role="tabpanel"
                                tabindex="0">Lorem ipsum dolor sit amet consectetur,
                                adipisicing elit. Ratione, iste aliquam? Nisi perferendis libero id ex consequatur
                                numquam illo eligendi commodi totam! Distinctio repellat incidunt magni tempora earum
                                explicabo expedita sed pariatur, molestias, aut ipsa, cumque eius ad. Officia fugit eius
                                eaque, nisi quidem qui ea hic repellat omnis dolores.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Tarjetas</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <app-information-card styleClass="primary" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                    <div class="col">
                        <app-information-card styleClass="secondary" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                    <div class="col">
                        <app-information-card styleClass="featured" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col">
                        <app-information-card styleClass="primary-white" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                    <div class="col">
                        <app-information-card styleClass="secondary-white" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                    <div class="col">
                        <app-information-card styleClass="featured-white" title="Lorem Ipsium" description="Lorem ipsum dolor sit amet consectetur
                        adipisicing elit. Vitae nesciunt ut enim, corporis nihil rerum molestias natus nulla a
                        obcaecati corrupti aliquid sequi!"></app-information-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Tablas</h1>
        <div class="col">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col"><input class="form-check-input" type="checkbox" value=""></th>
                            <th scope="col">LOREM</th>
                            <th scope="col">LOREM</th>
                            <th scope="col th-lg">LOREM</th>
                            <th scope="col">LOREM</th>
                            <th scope="col">LOREM</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-secondary shade">APROBADO <i class="bi bi-check"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-primary shade">RECHAZADO <i class="bi bi-x"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-warning shade">PENDIENTE <i class="bi bi-clock"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-secondary shade">APROBADO <i class="bi bi-check"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-primary shade">RECHAZADO <i class="bi bi-x"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                        <tr>
                            <td scope="row"><input class="form-check-input" type="checkbox" value=""></td>
                            <td>Lorem ipsum dolor sit amet consectetur ...</td>
                            <td><i class="bi bi-person-circle"></i></td>
                            <td>{{'09/12/2023' | date}}</td>
                            <td><span class="badge text-bg-secondary shade">APROBADO <i class="bi bi-check"></i></span>
                            </td>
                            <td>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut, sapiente vero. Est deleniti
                                commodi modi nesciunt explicabo.</td>
                            <td><button class="btn btn-outline-secondary">...</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
        <h1>Graficas</h1>
        <div class="col">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [data]="barChartData" [options]="barChartOptions"
                                [plugins]="barChartPlugins" [legend]="barChartLegend" [type]="'bar'">
                            </canvas>
                        </div>
                    </div>
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart width="400" height="400" [type]="'line'" [data]="lineChartData"
                                [options]="lineChartOptions" [legend]="lineChartLegend">
                            </canvas>
                        </div>
                    </div>
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [type]="'pie'" [datasets]="pieChartDatasets" [labels]="pieChartLabels"
                                [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend">
                            </canvas>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [labels]="doughnutChartLabels" [datasets]="doughnutChartDatasets"
                                [options]="doughnutChartOptions" [legend]="true" [type]="'doughnut'">
                            </canvas>
                        </div>
                    </div>
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [datasets]="radarChartDatasets" [options]="radarChartOptions"
                                [labels]="radarChartLabels" [type]="'radar'">
                            </canvas>
                        </div>
                    </div>
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [datasets]="polarAreaChartDatasets" [labels]="polarAreaChartLabels"
                                [legend]="polarAreaLegend" [options]="polarAreaOptions" [type]="'polarArea'">
                            </canvas>
                        </div>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [datasets]="bubbleChartDatasets" [options]="bubbleChartOptions"
                                [legend]="bubbleChartLegend" [type]="'bubble'">
                            </canvas>
                        </div>
                    </div>
                    <div class="col">
                        <div class="background-white">
                            <canvas baseChart [datasets]="scatterChartDatasets" [options]="scatterChartOptions"
                                [type]="'scatter'">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>